module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "hpcta"
    }
  }, [(_vm.siteInfo) ? _c('header', {
    staticClass: "circleHeader"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.siteInfo.homepageCTA.text)
    }
  }), _vm._v(" "), (_vm.siteInfo.homepageCTA.image) ? _c('img', {
    attrs: {
      "src": _vm.siteInfo.homepageCTA.image.sizes.medium,
      "alt": ""
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65e0be17"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/CallToAction.vue
// module id = 789
// module chunks = 1